module.exports = __webpack_public_path__ + "static/image0001-b672c209139383dbf90e7f0e0610d950.jpg";